import Login from '../components/login/Login.vue'
import BookingSearchPage from '../components/bookings/booking-search/BookingSearchPage.vue'
import BookingDetailPage from '../components/bookings/booking-detail/BookingDetailPage.vue'
import BookingCreatePage from '../components/bookings/booking-create/BookingCreatePage.vue'
import BookingCreateLoungePage from '../components/bookings/booking-create/BookingCreateLoungePage.vue'
import BookingCreateFastTrackPage from '../components/bookings/booking-create/BookingCreateFastTrackPage.vue'
import RouteNotFoundPage from '../components/route-not-found/RouteNotFoundPage.vue'
export default [{
    name: 'Login',
    path: '/login',
    component: Login
},
{
    path: '/',
    component: BookingSearchPage,
    meta: {
        requiresAuth: true,
        permissionsRequired: ['contact-centre.search.view']
    }
},
{
    path: '/booking/create',
    component: BookingCreatePage,
    meta: {
        requiresAuth: true,
        permissionsRequired: ['contact-centre.booking.create']
    }
},
{
    path: '/booking/:bookingId/modify',
    component: BookingCreatePage,
    meta: {
        requiresAuth: true,
        permissionsRequired: ['contact-centre.booking-details.view']
    }
},
{
    path: '/booking/createlounge',
    component: BookingCreateLoungePage,
    meta: {
        requiresAuth: true,
        permissionsRequired: ['contact-centre.booking.create']
    }
},
{
    path: '/booking/:bookingId/modify/lounge',
    component: BookingCreateLoungePage,
    meta: {
        requiresAuth: true,
        permissionsRequired: ['contact-centre.booking-details.view']
    }
},
{
    path: '/booking/createfasttrack',
    component: BookingCreateFastTrackPage,
    meta: {
        requiresAuth: true,
        permissionsRequired: ['contact-centre.booking.create']
    }
},
{
    path: '/booking/:bookingId/modify/fasttrack',
    component: BookingCreateFastTrackPage,
    meta: {
        requiresAuth: true,
        permissionsRequired: ['contact-centre.booking-details.view']
    }
},
{
    path: '/booking/:bookingId',
    component: BookingDetailPage,
    name: 'bookingDetail',
    meta: {
        requiresAuth: true,
        permissionsRequired: ['contact-centre.booking-details.view']
    }
},
{
    path: '/404',
    component: RouteNotFoundPage,
    name: '404'
}]
